import script from "./UserFeeEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFeeEdit.vue?vue&type=script&setup=true&lang=js"

import "./UserFeeEdit.vue?vue&type=style&index=0&id=13a9c3b0&lang=less"

const __exports__ = script;

export default __exports__